<template>
  <div>this is message</div>
</template>

<script>
export default {
  name: 'Message',
}
</script>

<style scoped>

</style>
